import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, LGAActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, LGAActions);

export default slice.reducer;
